import React from "react";
import PropTypes from "prop-types";
import SupportContactDialog from "../../../components/SupportContactDialog";
import RegisterBottomTabs from "./RegisterBottomTabs";
import RegisterPremiumCalculatorDialog from "./RegisterPremiumCalculatorDialog";

/** Bottom sticky tabs (wired to registration dialog toggles). */
export function RegisterPageBottomBar({ reg }) {
  return (
    <RegisterBottomTabs
      p={{ setOpenSupport: reg.setOpenSupport, setOpenCalculator: reg.setOpenCalculator }}
    />
  );
}

RegisterPageBottomBar.propTypes = {
  reg: PropTypes.shape({
    setOpenSupport: PropTypes.func.isRequired,
    setOpenCalculator: PropTypes.func.isRequired,
  }).isRequired,
};

/** Global overlays rendered outside the form column (support + calculator). */
export default function RegisterPageDialogs({ reg, supportContext = "Register" }) {
  return (
    <>
      <SupportContactDialog
        open={reg.openSupport}
        onClose={() => reg.setOpenSupport(false)}
        context={supportContext}
      />
      <RegisterPremiumCalculatorDialog
        p={{
          openCalculator: reg.openCalculator,
          handleCloseCalculator: () => reg.setOpenCalculator(false),
        }}
      />
    </>
  );
}

RegisterPageDialogs.propTypes = {
  reg: PropTypes.shape({
    openSupport: PropTypes.bool.isRequired,
    setOpenSupport: PropTypes.func.isRequired,
    openCalculator: PropTypes.bool.isRequired,
    setOpenCalculator: PropTypes.func.isRequired,
  }).isRequired,
  supportContext: PropTypes.string,
};
